import type { ReactNode } from 'react'

import { LanguageMenu } from '../LanguageMenu'
import { CheckoutHeader, CheckoutWrapper } from './CheckoutContainer.styled'

import LogoImage from '../../assets/images/speedy-logo.svg'

type CheckoutContainerProps = {
  className?: string
  hideHeader?: boolean
  hideLanguage?: boolean
  children?: ReactNode
}

export const CheckoutContainer = (props: CheckoutContainerProps) => {
  const { className, hideHeader = false, hideLanguage = false, children } = props

  return (
    <CheckoutWrapper className={className}>
      {hideHeader ? null : (
        <CheckoutHeader>
          <span className='logo'>
            <img src={LogoImage} alt='Logo' />
          </span>
          {hideLanguage ? null : (
            <span className='right'>
              <LanguageMenu />
            </span>
          )}
        </CheckoutHeader>
      )}
      {children}
    </CheckoutWrapper>
  )
}
